import { useCallback, useState } from "react";

const areTaskIdsEqual = (prevTaskIds: string[], nextTaskIds: string[]) => {
    if (prevTaskIds.length !== nextTaskIds.length) {
        return false;
    }

    return prevTaskIds.every((taskId, index) => taskId === nextTaskIds[index]);
};

export function useNavigationTaskIds() {
    const [navigationTaskIds, setNavigationTaskIds] = useState<string[]>([]);
    const handleNavigationTaskIdsChange = useCallback((taskIds: string[]) => {
        setNavigationTaskIds((prevTaskIds) =>
            areTaskIdsEqual(prevTaskIds, taskIds) ? prevTaskIds : taskIds,
        );
    }, []);

    return { navigationTaskIds, handleNavigationTaskIdsChange };
}
